import { FieldType, IModel, ViewModelBase } from "@shoothill/core";
import { action, computed, observable, runInAction } from "mobx";
import { StoresInstance } from "Globals/Stores";
import { SaveStore } from "Globals/Stores/Domain";

// App
import { FormSectionsEnum } from "Globals/Models/FormSectionsEnum";

type SaveCallback = () => Promise<void>;
export default class FormSectionViewModelBase<T extends IModel<T> = any> extends ViewModelBase<T> {
    @observable public DevTool_ShowCanProceed: boolean = false; // ! Devtool: set to true to show the canProceed indicator for each section
    @observable public saveStore: SaveStore = StoresInstance.Domain.SaveStore;
    @observable public updateSectionCompleted: (index: FormSectionsEnum, value: boolean) => void;
    @observable public saveFunction: SaveCallback | null;
    constructor(_updateSectionCompleted: (index: FormSectionsEnum, value: boolean) => void, model?: T, undoable?: boolean, enableProxy?: boolean) {
        super(model, undoable, enableProxy);
        this.updateSectionCompleted = _updateSectionCompleted;
        this.saveFunction = null;
    }
    // Autosave Timer - start
    @action
    public startTimer = (): void => {
        // JJ: Spoke with Josh and moved this from 5seconds to 10 seconds.
        // 5 seconds wasn't enough time for the user to scroll down and continue with the next section. The auto-save would kick in, then
        // they would start filling out the form, then the save would come back and be behind where they were.
        this.timer = setInterval(this.autoSave, 10000);
    };
    @action
    public restartTimer = (): void => {
        console.log("restart");
        this.stopTimer();
        this.startTimer();
    };
    @action
    public stopTimer = (): void => {
        clearInterval(this.timer);
    };
    @action
    public autoSave = async (): Promise<void> => {
        if (this.isModelDirty == false) return;
        this.stopTimer();
        if (this.saveFunction) {
            console.log("auto save.");
            this.saveStore.setIsSaved(false);
            this.saveStore.setIsSaving(true);
            await this.saveFunction();
            this.saveStore.setIsSaving(false);
            this.saveStore.setIsSaved(true);
        }
        this.startTimer();
    };
    private timer = setInterval(this.autoSave, 5000);
    // Autosave Timer - end
    @action
    public isEmptyNullOrUndefined = (value: any): boolean => {
        if (value === false || value === true) {
            return false;
        }
        if (value === "" || value === null || value === undefined) {
            return true;
        } else {
            return false;
        }
    };

    @computed
    public get isModelDirty(): boolean {
        let dirty = false;
        for (let i = 0; i < Object.keys(this.model).length; i++) {
            const field = Object.keys(this.model)[i];
            if (this.model.getDirty(field as keyof FieldType<T>)) {
                dirty = true;
            }
        }
        return dirty;
    }
    @action
    public setModelDirty(value: boolean): void {
        Object.keys(this.model).forEach((field) => {
            this.model.setDirty(field as keyof FieldType<T>, value);
        });
    }
    @action
    public async isFieldValid(fieldName: keyof FieldType<T>, value: any): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);
        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);
        return isValid;
    }
    public afterUpdate(fieldName: keyof FieldType<T>, value: any): void {
        console.log("afterUpdate");
        console.log("Field name: " + fieldName);
        if (fieldName != "reportsRequired") {
            this.saveStore.setIsSaved(false);
        }
        this.setDirty(fieldName, true);
        this.restartTimer();
    }
    public beforeUpdate?: (fieldName: keyof FieldType<T>, value: any) => any;
}
